import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import * as ApiHelper from "../../ApiHelper"
import { TableLayout } from "../../components"
import Moment from "moment"
import { ToastContainer, ToastMessage } from "react-toastr"
class TableNotasFiscaisTrash extends Component {
  constructor() {
    super()
    this.toastFactory = React.createFactory(ToastMessage.animation)
  }
  addAlert(title, message) {
    this.container.error(title, message, {
      timeOut: 5000,
      extendedTimeOut: 3000
    })
  }
  restore(event, id) {
    ApiHelper.restoreNota(id, error => {
      if (error) {
        this.addAlert("", error.message)
      } else {
        this.props.onRestore()
      }
    })
  }
  render() {
    var tableHeaders = [
      "Número da nota fiscal",
      "Data da nota fiscal",
      "Número do contrato",
      "Objeto do contrato",
      "Ações"
    ]
    return (
      <div>
        <ToastContainer
          ref={input => {
            this.container = input
          }}
          toastMessageFactory={this.toastFactory}
          className="toast-top-right"
          preventDuplicates={true}
        />
        <TableLayout
          headerButtons={[]}
          sizeClass={this.props.sizeClass}
          backgroundColor={this.props.backgroundColor}
          title={this.props.title}
          subtitle={this.props.subtitle}
          filter={this.props.filter}
          searchLabel="Pesquisar nota fiscal"
        >
          <table className="table table-hover">
            <thead className="text-warning">
              <tr>
                {tableHeaders.map((header, key) => {
                  return <th key={key}>{header}</th>
                })}
              </tr>
            </thead>
            <tbody>
              {this.props.rows.map((row, key) => {
                return (
                  <tr key={key}>
                    <td className="col-md-1">{row.numero}</td>
                    <td className="col-sm-1">
                      {Moment(row.data).format("D/MM/Y")}
                    </td>
                    <td className="col-sm-1">{row.contrato.num_contrato}</td>
                    <td className="col-sm-10">{row.contrato.objeto}</td>
                    <td className="td-actions text-right">
                      <button
                        title="Restaurar nota"
                        className="btn btn-danger btn-simple btn-xs"
                        onClick={event => this.restore(event, row.id)}
                      >
                        <i className="material-icons">restore</i>
                      </button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </TableLayout>
      </div>
    )
  }
}
export default withRouter(TableNotasFiscaisTrash)



// WEBPACK FOOTER //
// ./src/views/baixas/TableNotasFiscaisTrash.js